/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Guided_DescInputs */

const en_simple_door_guided_desc = /** @type {(inputs: Simple_Door_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A person does the hard part with you, at a fixed price.`)
};

const id_simple_door_guided_desc = /** @type {(inputs: Simple_Door_Guided_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manusia yang mengerjakan bagian sulitnya bersamamu, dengan harga tetap.`)
};

/**
* | output |
* | --- |
* | "A person does the hard part with you, at a fixed price." |
*
* @param {Simple_Door_Guided_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_guided_desc = /** @type {((inputs?: Simple_Door_Guided_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Guided_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_guided_desc(inputs)
	return en_simple_door_guided_desc(inputs)
});